import { useMemo } from 'react';

export const getLinkElement = (document: Document) => {
  const link = document.createElement('link');
  link.rel = 'stylesheet';
  return link;
};

export const useDocument = (): undefined | Document => useMemo(() => global.document, []);
